import React, { useEffect, useState } from 'react';
import { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { Environment, Stars, OrbitControls, PerspectiveCamera } from "@react-three/drei"
import Plate from './Plate';
import Loader from './Loader';
import ModelLogo from './ModelLogo';
import ModelStatue from './ModelStatue';
import ModelVoxel from './ModelVoxel';
import AnimationMenu from './AnimationMenu';

export default function Scene({ number, plateColor, imageData, setDisplaySelector}) {
  const [backgroundClass, setBackgroundClass] = useState('viewer-revealed');
  const isUnrevealed = imageData.attributes.some(a => a.trait_type === 'Reveal')
  const [animation, setAnimation] = useState('Wave 01')
  const [toggleMenu, setToggleMenu] = useState(false)
  
  const handleToggleMenu = () => {
    setToggleMenu(!toggleMenu)
  }
  

  useEffect(() => {
    const getBackgroundClass = () => {
      const time = new Date().getHours();
      if (time >= 6 && time < 12) {
        return 'viewer-revealed-morning';
      } else if (time >= 12 && time < 17) {
        return 'viewer-revealed-afternoon';
      } else if (time >= 17 && time < 21) {
        return 'viewer-revealed-evening';
      } else {
        return 'viewer-revealed-night';
      }
    };
    
    setBackgroundClass(getBackgroundClass());

    // Update background class every hour
    const interval = setInterval(() => {
      setBackgroundClass(getBackgroundClass());
    }, 60 * 60 * 1000);

    // Clear interval on unmount
    return () => clearInterval(interval);
  }, []);
  // console.log(number);

  const toggleVX = () => {
    setDisplaySelector(1)
  }

  const toggleNFT = () => {
    setDisplaySelector(0)
  }

  return (
    <div>
      <div className={`${!isUnrevealed ? `viewer-revealed ${backgroundClass}` : 'viewer'}`}>
      <div className="toggleDivScene" onDoubleClick={handleToggleMenu}>
        {toggleMenu && <AnimationMenu setAnimation={setAnimation} setDisplaySelector={setDisplaySelector} toggleVX={toggleVX} toggleNFT={toggleNFT}/>}
      </div>
      
        <Suspense fallback={<Loader />}>
          <Canvas shadows>
            <PerspectiveCamera position={[0, 0, 25]} fov={12} makeDefault />
            <spotLight
              position={[10, 12, 6]}
              angle={[0.5]}
              intensity={0.3}
              castShadow
              shadow-mapSize-width={2048}
              shadow-mapSize-height={2048}
              shadow-camera-left={-10}
              shadow-camera-right={10}
              shadow-camera-top={10}
              shadow-camera-bottom={-10}
              shadow-camera-near={0.1}
              shadow-camera-far={100}
            />
            {!isUnrevealed ? (
              <ModelVoxel number={number} animation={animation} />
            ) : (
              <ModelStatue />
            )}
            <Environment files="images/modern2.hdr">
              {isUnrevealed && <ModelLogo />}
            </Environment>
            {plateColor === undefined && <Plate color="#C0C0C0" />}
            {plateColor === 'Platinum' && <Plate color="#C0C0C0" />}
            {plateColor === 'Gold' && <Plate color="#ffad35" />}
            {plateColor === 'Diamond' && <Plate color="#36ffc9" />}
            {isUnrevealed && <ModelLogo/>}
            <Stars radius={5} depth={10} count={10000} factor={2} saturation={0} fade speed={1} />
            {!isUnrevealed ? 
              <OrbitControls minDistance={15} maxDistance={50}  enablePan={false} autoRotate autoRotateSpeed={0.1}/> 
            : 
              <OrbitControls minDistance={15} maxDistance={50}  enablePan={false} autoRotate autoRotateSpeed={1.5} />
            }
          </Canvas>
        </Suspense>
      </div>
      {/* <button className="changer" onClick={handleToggle}>Change</button> */}
    </div>
  );
}